import { PromoCampaign } from "providers/CampaignProvider";
import { createContext, useContext } from "react";

type ContextProps = {
    campaign: PromoCampaign | null;
};

export const CampaignContext = createContext<ContextProps>({ campaign: null });

export const useCampaignContext = () => useContext(CampaignContext);
